<div class="button-replay">
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 70.33 86.25">
    <g id="a4fa40bd-53b5-4f80-a86a-059ede14ce2d" data-name="Layer 2">
      <g id="ed7b9aea-1e4c-4724-8258-172fb0d0bd87" data-name="button_opnieuw">
        <g id="a60d87ba-41a7-4cc5-a285-9f60c1e5d0eb" data-name="button_opnieuw_up">
          <path
            d="M40.5,70.63C22.09,75.78,5,64,.66,43.35c-4-18.7,10.45-35.5,28.57-41.61,18.53-6.25,31.52,5,38.1,23C77.8,53.26,58.91,65.48,40.5,70.63"
            style="fill:#ffbc00" />
          <path
            d="M59.5,83.65c-1.31,1.51-10.6,2.6-22.87,2.6s-23.05-.86-22.86-2.74c.15-1.52,8.12-2.8,22.86-2.75,12.26,0,24.43,1.07,22.87,2.89"
            style="opacity:0.15" />
          <g id="ba98ed06-e923-4712-ab24-265f70ab38ab" data-name="button_replay">
            <path
              d="M36,21.18v-4a1.39,1.39,0,0,0-2.21-1.13L26,21.74A1.39,1.39,0,0,0,26,24l7.75,5.66A1.39,1.39,0,0,0,36,28.51V24.62A14.67,14.67,0,1,1,20.52,40.18a1,1,0,0,0-1-.93H18a1,1,0,0,0-1,1A18.11,18.11,0,1,0,36,21.18Z"
              style="fill:#fff" />
          </g>
        </g>
        <g id="e877dd62-f24b-480c-a93a-9fa4fbc186a2" data-name="button_opnieuw_down">
          <path
            d="M40.07,67.86C23.13,72.6,7.44,61.77,3.41,42.76-.23,25.55,13,10.09,29.7,4.47c17.05-5.75,29,4.61,35.06,21.13C74.39,51.87,57,63.12,40.07,67.86"
            style="fill:#bf8d00" />
          <path
            d="M58.14,83.64c-1.22,1.42-10,2.44-21.51,2.45S15,85.28,15.13,83.51c.14-1.43,7.64-2.64,21.5-2.59,11.54,0,23,1,21.51,2.72"
            style="opacity:0.15" />
          <g id="f67b9004-1edf-470b-a8f3-94b0cd358f62" data-name="button_replay">
            <path
              d="M35.93,22.36V18.7a1.28,1.28,0,0,0-2-1l-7.13,5.2a1.28,1.28,0,0,0,0,2.07l7.13,5.2a1.28,1.28,0,0,0,2-1V25.52A13.49,13.49,0,1,1,21.69,39.84a.9.9,0,0,0-.88-.86h-1.4a.89.89,0,0,0-.89.91A16.66,16.66,0,1,0,35.93,22.36Z"
              style="fill:#f5f0df" />
          </g>
        </g>
      </g>
    </g>
  </svg>
</div>
